import React from 'react';
import { motion } from 'framer-motion';
import { CarIcon, BusIcon, PlaneIcon, ClockIcon } from 'lucide-react';
export interface TransferProps {
  id: string;
  type: 'Private Car' | 'Luxury Bus' | 'Helicopter' | 'Yacht';
  destination: string;
  duration: string;
  description: string;
}
interface TransferCardProps {
  transfer: TransferProps;
}
export function TransferCard({
  transfer
}: TransferCardProps) {
  const getIcon = () => {
    switch (transfer.type) {
      case 'Private Car':
        return <CarIcon className="w-5 h-5" data-id="element-101" />;
      case 'Luxury Bus':
        return <BusIcon className="w-5 h-5" data-id="element-102" />;
      case 'Helicopter':
        return <PlaneIcon className="w-5 h-5" data-id="element-103" />;
      case 'Yacht':
        return <PlaneIcon className="w-5 h-5" data-id="element-104" />;
      // Fallback, lucide doesn't have a great yacht icon by default
      default:
        return <CarIcon className="w-5 h-5" data-id="element-105" />;
    }
  };
  return <motion.div whileHover={{
    scale: 1.02
  }} className="flex items-center p-4 bg-cream-100/50 border border-cream-200 rounded-sm hover:bg-white hover:shadow-luxury transition-all duration-300 group" data-id="element-106">
      <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-navy-900 text-gold-400 rounded-sm group-hover:bg-gold-500 group-hover:text-navy-900 transition-colors duration-300" data-id="element-107">
        {getIcon()}
      </div>

      <div className="ml-4 flex-grow" data-id="element-108">
        <h4 className="text-base font-serif font-medium text-navy-900" data-id="element-109">
          {transfer.type} to {transfer.destination}
        </h4>
        <p className="text-sm text-navy-800/60 mt-0.5" data-id="element-110">
          {transfer.description}
        </p>
      </div>

      <div className="flex-shrink-0 flex items-center space-x-1.5 text-sm font-medium text-navy-800 bg-white px-3 py-1.5 rounded-full border border-cream-200 shadow-sm" data-id="element-111">
        <ClockIcon className="w-4 h-4 text-gold-500" data-id="element-112" />
        <span data-id="element-113">{transfer.duration}</span>
      </div>
    </motion.div>;
}